"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.convertLanguageCodeToRegionalCode = convertLanguageCodeToRegionalCode;
var _replaceAll = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/replace-all"));
var _constants = require("../constants");
/**
 * Converts a given language code to a standardized regional code.
 *
 * @param {string} languageCode - The language code to convert.
 * @returns {string} - The converted regional language code.
 */
function convertLanguageCodeToRegionalCode(languageCode) {
  // Converting underscores to hyphens
  let convertedLanguageCode = (0, _replaceAll.default)(languageCode).call(languageCode, '_', '-');
  switch (languageCode) {
    case 'de-DE':
      convertedLanguageCode = 'de';
      break;
    case 'es':
    case 'es-AR':
    case 'es-419':
      convertedLanguageCode = 'es-419';
      break;
    case 'en':
    case 'en-GB':
      convertedLanguageCode = _constants.defaultLanguage;
      break;
    case 'fr':
    case 'fr-CA':
      convertedLanguageCode = 'fr-CA';
      break;
    case 'ja-JP':
      convertedLanguageCode = 'ja';
      break;
    case 'pt-PT':
    case 'pt':
      convertedLanguageCode = 'pt-BR';
      break;
    case 'zh':
      convertedLanguageCode = 'zh-CN';
      break;
  }
  return convertedLanguageCode;
}